export default "__VITE_ASSET__11108a57__"